import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import SearchBar from '../components/SearchBar';
import FooterBar from '../components/FooterBar';
import Movie from '../components/Movie';
import Loader from '../components/Loader';
import Toast from '../components/Toast';
import { useGlobalContext } from '../Context';
import { GlobalStyle } from '../GlobalStyles';

const MyListPage = () => {
  const { myList, isLoading, removeFromList, showToast, setShowToast } =
    useGlobalContext();
  const [deleteBtn] = useState(true);

  useEffect(() => {
    setShowToast({
      heading: '',
      msg: '',
      isShowing: false,
    });
  }, [setShowToast]);

  if (isLoading) {
    return (
      <div className='app-wrapper'>
        <Navbar />
        <SearchBar />
        <Loader />
        <FooterBar />
        <GlobalStyle />
      </div>
    );
  }

  return (
    <div className='app-wrapper'>
      <Navbar />
      <SearchBar />
      <div className='section-heading'>
        <h4>My List Page</h4>
        {myList.length > 0 || <h5>You have no items in your movie list</h5>}
      </div>
      <div className='block-wrapper'>
        {myList.map((movie) => {
          return (
            <Movie
              key={movie.id}
              movie={movie}
              deleteBtn={deleteBtn}
              removeFromList={removeFromList}
            />
          );
        })}
      </div>
      <FooterBar />
      {showToast.isShowing && (
        <Toast heading={showToast.heading} message={showToast.msg} />
      )}
      <GlobalStyle />
    </div>
  );
};

export default MyListPage;
